import React, { useEffect, useRef } from "react";
import LSQFrame from "../../../ReusableComponents/LSQFrame/LSQFrame";
import Icon from "../../../../dashboard/Icon/Icon";
import TasksHeader from "../../TasksHeader/TasksHeader";
import HoursIndicate from "../HoursIndicate/HoursIndicate";
import CurrentTime from "../CurrentTime/CurrentTime";
import { hourHeight, maxTasksInRow } from "../../calendar";
import { getOverlaptasks, scrollToCurrentTime } from "../../helper/helper";
import { TEXT_CONSTANTS } from "../../../../utils/constants";
import List from "./List/List";

const CalendarTasks = ({ selectedDate, appointments }) => {
  const [updatedTasks, maxOverlapCount] = getOverlaptasks(appointments);
  const timelineRef = useRef();
  const timelineHeight = hourHeight * 24;
  const calculatedWidth =
    maxOverlapCount > maxTasksInRow
      ? `calc(${(maxOverlapCount * 100) / maxTasksInRow}% + 50px)`
      : "100%";

  useEffect(() => {
    scrollToCurrentTime(true, timelineRef);
    const intervalId = setInterval(
      () => scrollToCurrentTime(false, timelineRef),
      60000
    );
    return () => clearInterval(intervalId);
  }, []);

  if (updatedTasks.length === 0)
    return (
      <LSQFrame className="calender-empty" role="appointments-empty">
        <Icon src={"assets/icons/empty_state.svg"} alt="icon" isWidgetIcon={false} />
        <label>{TEXT_CONSTANTS.noAppointmentsScheduled}</label>
      </LSQFrame>
    );

  return (
    <TasksHeader appointments={updatedTasks.length} refObj={timelineRef}>
      <div ref={timelineRef} className="timeline-container">
        <div style={{ height: `${timelineHeight}px` }}>
          <HoursIndicate calculatedWidth={calculatedWidth} />
          <CurrentTime calculatedWidth={calculatedWidth} />
          <List selectedDate={selectedDate} updatedTasks={updatedTasks} />
        </div>
      </div>
    </TasksHeader>
  );
};

export default CalendarTasks;
